export default class DriverModel {
    constructor() {
        this.sapId = undefined;
        this.firstName = '';
        this.lastName = '';
        this.pesel = '';
        this.oldPesel = '';
        this.documentNumber = '';
        this.own = true;
    }

    static assign(from, to) {
        if (from) {
            to.sapId = from.sapId ? from.sapId : undefined;
            to.firstName = from.firstName ? from.firstName : '';
            to.lastName = from.lastName ? from.lastName : '';
            to.pesel = from.pesel ? from.pesel : '';
            to.oldPesel = from.oldPesel ? from.oldPesel : '';
            to.documentNumber = from.documentNumber ? from.documentNumber : '';
            to.own = from.own;
        } else {
            to = new DriverModel();
        }
    }

    static copy(from) {
        const to = new DriverModel();
        DriverModel.assign(from, to);
        return to;
    }
}